<template>
  <div>
    <h1 class="mt-5">{{ this.title || 'Error' }}</h1>
    <hr />
    <p v-if="this.message">{{ this.message }}</p>
    <p v-else>
      The application encountered an error it could not recover from. If this
      problem persists, please contact OFDIT.
      <a href="mailto:ofdit@sps.cuny.edu"><b-icon icon="envelope"></b-icon></a>
    </p>
    <div v-if="this.errObj">
      <h3>Additional information</h3>
      <code v-html="prettyPrintObject(this.errObj)"></code>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'ErrorPage',
    props: {
      title: String,
      message: String,
      errObj: Object
    },
    methods: {
      prettyPrintObject(Obj) {
        return JSON.stringify(Obj, null, 2)
      }
    }
  }
</script>

<style>
  code {
    white-space: pre-wrap;
  }
</style>
